/**
 * Botón de silenciar/activar sonido, reutilizable en cualquier escena (HUD
 * de partida, header del lobby). Alterna `AudioManager` (música + SFX,
 * preferencia persistida en localStorage) y refleja el estado con un ícono.
 * Zona táctil ≥44px (criterio de accesibilidad del plan).
 */

import Phaser from 'phaser';
import { audio } from '../core/AudioManager';

const TAP_SIZE = 44;

export class AudioToggleButton extends Phaser.GameObjects.Container {
  private readonly icon: Phaser.GameObjects.Text;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y);

    this.icon = scene.add
      .text(0, 0, audio.isMuted ? '🔇' : '🔊', { fontSize: '16px' })
      .setOrigin(0.5);
    this.add(this.icon);

    this.setSize(TAP_SIZE, TAP_SIZE);
    // hitArea desde la esquina superior-izquierda: Phaser suma displayOrigin
    // (= origin × setSize) al punto local antes de evaluarlo (ver uiKit.ts).
    this.setInteractive({
      useHandCursor: true,
      hitArea: new Phaser.Geom.Rectangle(0, 0, TAP_SIZE, TAP_SIZE),
      hitAreaCallback: Phaser.Geom.Rectangle.Contains,
    });
    this.on('pointerdown', () => this.handleToggle());

    scene.add.existing(this);
  }

  private handleToggle(): void {
    // primer toque de la sesión: además de silenciar/activar, desbloquea el
    // audio del navegador (política de autoplay) por si aún no había sonado nada.
    audio.unlock();
    const muted = audio.toggleMuted();
    this.icon.setText(muted ? '🔇' : '🔊');
    this.scene.tweens.add({
      targets: this,
      scale: 0.8,
      duration: 90,
      yoyo: true,
      ease: 'Sine.InOut',
    });
  }
}
